const minimumCredentialLength = 3

export function getAlternateCredentialsError(
  altLogin: string,
  altPassword: string
): string | undefined {
  if (altPassword.length > 0 && altLogin.length === 0) {
    return 'If you specify an alt password you must also specify an alt user'
  }

  if (
    (altLogin.length > 0 && altLogin.length < minimumCredentialLength) ||
    (altPassword.length > 0 && altPassword.length < minimumCredentialLength)
  ) {
    return 'Minimum 3 character required for alt login and password'
  }

  if (altPassword.length > 0 && altLogin === altPassword) {
    return 'Alt login and password cannot be the same'
  }
}
